// extracted by mini-css-extract-plugin
export default {"tabContainer":"GamesTabs__tabContainer--1_0","tab":"GamesTabs__tab--2Wb","disabled":"GamesTabs__disabled--yUE","active":"GamesTabs__active--2G_"};